import { forwardRef, type ComponentPropsWithoutRef, type ElementRef } from 'react';
import * as Toast from '@radix-ui/react-toast';
import { cn } from '@/utils/helpers';

export const ToastProvider = Toast.Provider;

export const ToastViewport = forwardRef<ElementRef<typeof Toast.Viewport>, ComponentPropsWithoutRef<typeof Toast.Viewport>>(
  ({ className, ...props }, ref) => {
    return <Toast.Viewport ref={ref} className={cn('ui-toast-viewport', className)} {...props} />;
  }
);
ToastViewport.displayName = 'ToastViewport';

export const ToastRoot = forwardRef<ElementRef<typeof Toast.Root>, ComponentPropsWithoutRef<typeof Toast.Root>>(
  ({ className, ...props }, ref) => {
    return <Toast.Root ref={ref} className={cn('ui-toast', className)} {...props} />;
  }
);
ToastRoot.displayName = 'ToastRoot';

export const ToastTitle = Toast.Title;
export const ToastDescription = Toast.Description;
export const ToastAction = Toast.Action;
export const ToastClose = Toast.Close;

